import { Moment } from 'moment-mini'
import { Resource } from 'src/app/shared/interfaces'
import { Product } from '../../../product/product'
import { SerieProposal } from '../serie-proposal'

export enum SerieProposalItemStatus {
  REQUESTED = 0,
  ACCEPTED = 1,
  COUNTER_PROPOSAL = 2,
  DECLINED = 3
}

export class SerieProposalItem extends Resource {
  id?: number
  serieProposalId?: number
  linkedProductId: number
  productId: number
  committed?: boolean
  startDate: any
  endDate: any
  status: SerieProposalItemStatus
  createdAt?: Moment
  updatedAt?: Moment
  // TODO: remove saleItemId
  saleItemId?: number
  bookingId?: number
  // relations
  serieProposal?: SerieProposal
  product?: Product

  // runtime prop
  dontSendMail?: boolean
}
